// removed by extract-text-webpack-plugin
module.exports = {"story":"_2BiELN9T09fR8qPp9RAu_M","header":"_2Cm8exUEu6Al2HJOuPMJgR _35grVg_J3M0lMvKJwKpoxZ","when":"_11mJJjpBGIw8GHY8nuwEhN","categories":"_3GtqQUWFhcXBhg99zriULW","category":"_1w4sIbFlQytEM_bEld_HW2","body":"_2HK30UhxaSXOCJ1EPb93Sr _35grVg_J3M0lMvKJwKpoxZ","thumb":"_25kxPLuS9NJ2wjrvGGGbJY _1_olABk0Q-537SFX_tUniJ","text":"_2rpgdAivF_pmhg0Q9324l","link":"XpT1ikeFH_gta54JlSTD4","title":"X9Qjqs7yUMb_t4ycCll-4","title_url":"_5PZcz5LDMc1KRxp74DyQP X9Qjqs7yUMb_t4ycCll-4","url":"_2yZMohnN45oPqb6lMD6FRV","roles":"CzlFsmlfu8RWkN3gpyEF1","desc":"_1TIZxxnH7r8qOpY6SWJp3t"};


//////////////////
// WEBPACK FOOTER
// ./src/History.css
// module id = 8
// module chunks = 0